import { DropFileMessage } from "../../../messages/file/FileMessages";
import { busService } from "../../bus";
import { RemoveSubModelMessage } from "flavr-common";
class DropFileService {
    constructor() {
        this.connection = busService.connection("DropFileService");
        this.modelSubscriptions = new Map();
        this.handleDropFileMessage = (msg) => {
            for (const callback of this.modelSubscriptions.values()) {
                callback(msg.url, msg.name, msg.type, msg.size, msg.lastModified);
            }
        };
        this.handleRemoveSubModelMessage = (msg) => {
            this.modelSubscriptions.delete(msg.uid);
        };
        this.connection.subscribeByType(DropFileMessage, this.handleDropFileMessage);
        this.connection.subscribeByType(RemoveSubModelMessage, this.handleRemoveSubModelMessage);
    }
    subscribeByUID(uid, callback) {
        this.modelSubscriptions.set(uid, callback);
    }
    unsubscribeByUID(uid) {
        this.modelSubscriptions.delete(uid);
    }
}
export const dropFileService = new DropFileService();
